import script from "./TheoDoiVtptThuHoiPrintTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheoDoiVtptThuHoiPrintTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./TheoDoiVtptThuHoiPrintTemplate.vue?vue&type=style&index=0&id=28b3905e&lang=scss&scoped=true"
import "./TheoDoiVtptThuHoiPrintTemplate.vue?vue&type=style&index=1&id=28b3905e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b3905e"]])

export default __exports__